export default "__VITE_ASSET__mFPPK8z9__"